import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AccountTypeLayer from "../../components/Settings/AccountTypeLayer";

const AccountTypePage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Account Type Management" />
        <AccountTypeLayer />
      </MasterLayout>
    </>
  );
};

export default AccountTypePage;
